import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  message: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  }
});
